import React from "react";
import { NewFeatureButton } from "../Button";
import FlatDownloadIcon from "@ecologi/assets/icons/download-flat-tray.svg";

type Props = {
  onClick: () => void;
  opaque?: boolean;
};

export const CreateReportButton = ({ onClick, opaque = false }: Props) => (
  <NewFeatureButton
    opaque={opaque}
    label="Generate a report"
    rightIcon={<FlatDownloadIcon />}
    onClick={onClick}
  />
);
